"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChip = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledChip = (0, styled_components_1.default)(material_1.Chip) `
  && {
    &.upload-type--manual {
      color: ${ui_components_1.baseColors.primaryBlue500};
      background-color: ${ui_components_1.baseColors.primaryBlue100};
    }

    &.upload-type--automatic {
      color: ${ui_components_1.baseColors.red};
      background-color: ${ui_components_1.baseColors.red100};
    }
  }
`;
